"use strict";

require('./renderers/badge');
require('./renderers/boolean');
require('./renderers/suffix');
require('./renderers/prefix');
